import React from 'react';

/**
 * Tiroir « Alliances » — port fidèle du prototype (`network.js` drawerAlliances).
 * La mécanique de renfort inter-joueurs n'est pas encore spécifiée : l'accès est
 * réservé au Community Manager (roles_id = 1). L'entrée reste visible pour signaler
 * que la fonctionnalité arrive.
 */

const ALLIANCES_ROLE_MAX = 1; // Community Manager uniquement

const ROLE_LABELS: Record<number, string> = {
  1: 'Community manager',
  2: 'Administrateur',
  3: 'Modérateur',
  4: 'Groupe de réflexion',
};
const roleLabel = (r?: number | null): string => ROLE_LABELS[Number(r)] || 'Chef de salle';

interface Props {
  rolesId?: number | null;
}

const AlliancesDrawer: React.FC<Props> = ({ rolesId }) => {
  const ouvert = Number(rolesId ?? 99) <= ALLIANCES_ROLE_MAX;

  if (!ouvert) {
    return (
      <div className="locked">
        <div className="locked__ico">🔒</div>
        <p className="locked__t">Alliances — prévu pour une mise à jour future</p>
        <p className="locked__d">
          La mécanique de renfort entre joueurs n'est pas encore spécifiée : l'accès est réservé au
          Community Manager le temps de la concevoir. L'entrée reste visible pour que les joueurs
          sachent que ça arrive.
        </p>
        <p className="locked__r mono">
          Accès actuel : {roleLabel(rolesId)} — requis : {ROLE_LABELS[1]}
        </p>
      </div>
    );
  }

  return (
    <>
      <p className="dintro">
        Accès Community Manager. La mécanique de renfort inter-joueurs reste à spécifier : cet écran
        sera enrichi une fois le design d'alliances arrêté.
      </p>
      <div className="empty">Aucune alliance configurée pour l'instant.</div>
    </>
  );
};

export default AlliancesDrawer;
